import { render, staticRenderFns } from "./MealsTypeDelete.vue?vue&type=template&id=3fc3b032&scoped=true&"
import script from "./MealsTypeDelete.vue?vue&type=script&lang=js&"
export * from "./MealsTypeDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc3b032",
  null
  
)

export default component.exports